var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70047 15.8997L4.80047 11.9997L8.70047 8.09973C9.09047 7.70973 9.09047 7.08973 8.70047 6.69973C8.31047 6.30973 7.69047 6.30973 7.30047 6.69973L2.71047 11.2897C2.32047 11.6797 2.32047 12.3097 2.71047 12.6997L7.30047 17.2997C7.69047 17.6897 8.31047 17.6897 8.70047 17.2997C9.09047 16.9097 9.09047 16.2897 8.70047 15.8997ZM15.3005 15.8997L19.2005 11.9997L15.3005 8.09973C14.9105 7.70973 14.9105 7.08973 15.3005 6.69973C15.6905 6.30973 16.3105 6.30973 16.7005 6.69973L21.2905 11.2897C21.6805 11.6797 21.6805 12.3097 21.2905 12.6997L16.7005 17.2997C16.3105 17.6897 15.6905 17.6897 15.3005 17.2997C14.9105 16.9097 14.9105 16.2897 15.3005 15.8997Z",
    fill: "#2F3037"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeRounded);
export default __webpack_public_path__ + "static/media/codeRounded.58a5bf10dcb40585001fc26765a0a7ec.svg";
export { ForwardRef as ReactComponent };